/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Portal_SettingsInputs */

const cs_portals_portal_settings = /** @type {(inputs: Portals_Portal_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavení portálu`)
};

const en_portals_portal_settings = /** @type {(inputs: Portals_Portal_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal settings`)
};

/**
* | output |
* | --- |
* | "Portal settings" |
*
* @param {Portals_Portal_SettingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_portal_settings = /** @type {((inputs?: Portals_Portal_SettingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Portal_SettingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_portal_settings(inputs)
	return cs_portals_portal_settings(inputs)
});